import noAuthApiClient from 'hub-http/clients/noAuthApiClient'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'I18n... Remove this comment to see the full error message

import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import { createTracker } from 'usage-tracker-public'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import { checkUserLoggedIn } from 'ecosystem-marketplace-apps-base/actions/AuthActions'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import { setApiBase as setEcosystemApiBase } from 'ecosystem-marketplace-apps-base/clients/ecosystemClient'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import { getPublicRootUrl } from 'ecosystem-marketplace-apps-base/utils/urls'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import { getTrackerConfig } from 'ecosystem-marketplace-apps-base/utils/usageTracker'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import PublicApplication from 'ecosystem-marketplace-apps-base/components/PublicApplication'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import App from 'ecosystem-marketplace-apps-base/App';
import rhumbConfig from '../rhumb-config.yaml';
setEcosystemApiBase('ecosystem/public/v1');
const languageCode = window.I18N_MANUAL_LANG;
const I18nProvider = createPublicI18nProvider({
  manuallySetLocale: true
});
I18nProvider.setLocale({
  locale: languageCode,
  langEnabled: true
});

const getPublicTrackerConfig = () => {
  return Object.assign({}, getTrackerConfig('public'), {
    isExternalHost: false
  });
};

const config = {
  ApplicationComponent: PublicApplication,
  apiClient: noAuthApiClient,
  appName: 'ecosystem-marketplace-apps-public-ui',
  blockingActions: [checkUserLoggedIn],
  rootUrl: getPublicRootUrl(languageCode),
  usageTracker: createTracker(getPublicTrackerConfig()),
  isPublic: true,
  I18nProvider,
  rhumbConfig
};
new App(config).start();